import React, {ReactElement, useEffect} from 'react';
import {useDispatch} from 'react-redux';

import Layout from '../features/game/components/Layout';
import {GameSettingsActions} from '../features/game/gameSettingsSlice';
import {useGameSettings} from '../features/game/hooks/useGameSettings';
import {useGameSettingsQuery} from '../features/query/graphql';

type Props = {};

const PlayGame = ({}: Props): ReactElement => {
  const gameSettings = useGameSettings();
  const dispatch = useDispatch();
  const settingsQuery = useGameSettingsQuery(undefined, {enabled: !gameSettings.loaded});

  useEffect(() => {
    if (!gameSettings.loaded && !settingsQuery.isLoading && !settingsQuery.isError) {
      console.log('Loading initial settings');
      dispatch(GameSettingsActions.setSettings(settingsQuery.data.game.settings));
    }
    if (settingsQuery.isError) {
      console.error(settingsQuery.error);
    }
  }, [
    dispatch,
    gameSettings.loaded,
    settingsQuery.data,
    settingsQuery.error,
    settingsQuery.isError,
    settingsQuery.isLoading,
  ]);

  return <Layout />;
};

export default PlayGame;
